module.exports = __webpack_public_path__ + "static/media/lucy45.57701661.png";